module.exports = __webpack_public_path__ + "img/send-icon.506a99c3.svg";